// services/threeService.js
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

export function createRenderer(container) {
  const renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(container.clientWidth, container.clientHeight);
  renderer.setPixelRatio(window.devicePixelRatio);
  container.appendChild(renderer.domElement);
  return renderer;
}

export function createCamera(container) {
  const camera = new THREE.PerspectiveCamera(45, container.clientWidth / container.clientHeight, 0.1, 1000);
  camera.position.set(0, 2, 5);
  return camera;
}

export function addLights(scene) {
  const light = new THREE.AmbientLight(0xF8F4E1, 1.5);
  scene.add(light);

  const directionalLight = new THREE.DirectionalLight(0xffffff, 4);
  directionalLight.position.set(5, 5, 5);
  scene.add(directionalLight);

  const secondLight = new THREE.DirectionalLight(0xffffff, 4);
  secondLight.position.set(-5, 5, 5);
  scene.add(secondLight);

  const backLight = new THREE.DirectionalLight(0xffffff, 1);
  backLight.position.set(0, 1, -2);
  scene.add(backLight);
}

export function loadModel(modelUrl, onLoad, onError) {
  const loader = new GLTFLoader();
  loader.load(modelUrl, onLoad, undefined, onError);
}

export function centerAndScaleModel(model, targetSize = 2.5) {
  const bbox = new THREE.Box3().setFromObject(model);
  const center = bbox.getCenter(new THREE.Vector3());
  const size = bbox.getSize(new THREE.Vector3());

  model.position.sub(center);

  const maxDim = Math.max(size.x, size.y, size.z);
  const scaleFactor = targetSize / maxDim;
  model.scale.setScalar(scaleFactor);
}

export function setModelColor(model, colorMode) {
  const colorMap = {
    blue: 0x9FB3DF,
    gray: 0xffdbac,
    green: 0x90C67C,
    eyesBlue: 0x3399ff,
  };

  model.traverse((child) => {
    if (child.isMesh && child.material && child.material.color) {
      child.material.color.setHex(colorMap[colorMode]);
      child.material.needsUpdate = true;
    }
  });
}
